<script>
export default {
  name: "IconImageFilled"
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="currentColor">
      <path
        d="M13,0c1.7,0,3,1.3,3,3v10c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3H13z M13.4,1.6 H2.6c-0.6,0-1,0.4-1,1l0,0v7.7l2.7-2.2c0.3-0.3,0.8-0.2,1.1,0.1l0,0l1.8,1.8l3.4-3.4c0.3-0.3,0.7-0.3,1.1-0.1l0,0l2.7,2.2V2.6 C14.4,2,14,1.6,13.4,1.6L13.4,1.6z"
      />
      <circle cx="4.8" cy="4.8" r="1.6" />
    </g>
  </svg>
</template>
